<label class="checkbox" [class.is-disabled]="disabled()" [style.width.px]="size()" [style.height.px]="size()">
  <input class="checkbox-container" type="checkbox" [checked]="value()" [disabled]="disabled()" (input)="toggleChecked()" [name]="iconName()">
  <ui-inline-svg class="checkbox-icon" [name]="iconName()"></ui-inline-svg>
</label>
